import React from 'react'
import moment from 'moment'
import { ModalTitle, ModalInfo } from 'src/styles/pages/Scheduling'
import UserIconRounded from 'static/icons/pet-anjo-user-circle.svg'
import LockAlt from 'static/icons/lock-alt.svg'
import { assetPrefix } from 'config/env_config'
// Components
import ProfessionalProfile from 'components/professionalProfile'
import LoginForm from 'components/loginForm/v2'
import SignupForm from 'components/signupForm'
import Terms from 'components/terms'
import ConfirmAccountForm from 'components/confirmAccountForm'
import ForgotPasswordForm from 'components/forgotPasswordForm'
import ResetPasswordForm from 'components/resetPasswordForm'
import IncompletePetDataForm from '../components/incompletePetDataForm'

const siteRecaptchaKey = process.env.RECAPTCHA_SITE_KEY_LOGIN

const SCHEDULE_ERROR_GENERIC = (onConfirm, phone) => ({
  type: 'warning',
  title: 'Desculpe, no momento este agendamento não pode ser realizado.',
  body: `Você pode marcar um horário diretamente na loja ou pelo telefone ${phone}.`,
  cancelLabel: 'Fechar',
  fullButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  onConfirm: onConfirm
})

const PARTNER_NOT_FOUND = (storeName) => ({
  type: 'warning',
  title: 'Desculpe, não encontramos um resultado para essa busca',
  cancelLabel: 'Fechar',
  body: (
    <>
      Sugerimos que tente encontrar pelo CEP, ativar sua localização ou consultar as unidades disponíveis em{' '}
      <a href='https://www.cobasi.com.br/institucional/nossas-lojas'>Nossas lojas</a>.
    </>
  ),
  fullButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`
})

const STEP_UPDATE = (onConfirm, onCancel) => ({
  type: 'warning',
  title: 'Atenção: Alteração de etapa necessária',
  body: (
    <>
      Uma das etapas deste agendamento<br />
      precisa ser escolhida novamente. Altere a<br />
      etapa ou crie um novo agendamento.<br />
    </>
  ),
  outlineCancelButton: true,
  fullButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  cancelLabel: 'Novo agendamento',
  confirmLabel: 'Alterar etapa',
  onConfirm: onConfirm,
  onCancel: onCancel
})

const REPEAT_SCHEDULE_DATE_SELECTION = (onConfirm, onCancel, schedulingInfo) => ({
  type: 'warning',
  title: (
    <>
      Repetir Agendamento: <br />
      Escolha a nova data!
    </>
  ),
  body: (
    <>
      Confira os detalhes deste  <br />agendamento: <br />
      <b>Serviço:</b> {schedulingInfo?.service}<br />
      <b>Loja:</b> {schedulingInfo?.partner}<br />
      <b>Profissional:</b> {schedulingInfo?.professional}<br /><br />
      Clique em ”Continuar” para escolher a<br /> nova data e o horário.
    </>
  ),
  outlineCancelButton: true,
  fullButton: true,
  icon: `${assetPrefix}/static/icons/Repeat.svg`,
  cancelLabel: 'Cancelar',
  confirmLabel: 'Continuar',
  onConfirm: onConfirm,
  onCancel: onCancel,
  titleSize: '16px',
  iconSize: '48px'
})

const EDIT_PET_WARNING = (onConfirm) => ({
  type: 'warning',
  title: 'Tem certeza que deseja editar as informações do pet agora?',
  body: 'Ao redirecionar para edição dos dados do pet, todas as informações deste agendamento serão perdidas.',
  confirmLabel: 'Continuar',
  cancelLabel: 'Voltar para o agendamento',
  fullButton: true,
  outlineCancelButton: true,
  icon: `${assetPrefix}/static/icons/triangle-exclamation.svg`,
  onConfirm: onConfirm
})

const NEW_PET_WARNING = (onConfirm) => ({
  type: 'warning',
  title: 'Tem certeza que deseja cadastrar um novo pet agora?',
  body: 'Ao redirecionar para cadastrar o novo pet, todas as informações deste agendamento serão perdidas.',
  confirmLabel: 'Continuar',
  cancelLabel: 'Voltar para o agendamento',
  outlineCancelButton: true,
  fullButton: true,
  icon: `${assetPrefix}/static/icons/triangle-exclamation.svg`,
  onConfirm: onConfirm
})

const LOCATION_NOT_ALLOWED = () => ({
  type: 'warning',
  title: 'Localização indisponível',
  cancelLabel: 'Fechar',
  body: (
    <>
      Estamos sem acesso à sua localização. Por favor, insira o seu endereço manualmente ou autorize nas permissões do seu aparelho.
    </>
  ),
  fullButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`
})

const DUPLICATED_SCHEDULING_WARNING = (onConfirm, errorMessage) => ({
  visible: true,
  type: 'warning',
  title: 'Atenção: Agendamento duplicado',
  confirmLabel: 'Escolher nova data',
  onConfirm: onConfirm,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  fullButton: true,
  showClose: false,
  body: (
    <>
      {errorMessage.split('\n')?.map((str, index) => (
        <div key={index}>
          <ModalInfo noMarginBottom>{str}</ModalInfo>
          <br />
        </div>
      ))}
      <ModalInfo>Ex: Se você tem um agendamento para o dia 19, não conseguirá realizar um novo nos dias 18 e 20.</ModalInfo>
    </>
  )
})

const PROFESSIONAL_PROFILE = (professional, servicesList, partner) => ({
  professional: true,
  type: 'professionalInfo',
  title: '',
  body: (
    <ProfessionalProfile
      professional={professional}
      servicesList={servicesList}
      partner={partner}
    />
  )
})

const getReschedulingModalBody = (hasSchedulingChanged, scheduleBody, schedulingData, havePayment, professionalName) => {
  if (hasSchedulingChanged) {
    return (
      <>
        <ModalInfo>Confirme os novos dados do reagendamento</ModalInfo>
        <ModalInfo>
          <strong>Profissional:</strong> {professionalName}
        </ModalInfo>
        <ModalInfo>
          <strong>Data:</strong>{' '}
          {moment(scheduleBody.selectDay).format('DD/MM/YYYY')}
        </ModalInfo>
        <ModalInfo>
          <strong>Horário:</strong> {scheduleBody.selectTime}
        </ModalInfo>
        <br />
        <ModalInfo>
          Importante: O reagendamento é gratuito, verifique com a recepção se as mudanças feitas podem ter alterado o valor.
        </ModalInfo>
      </>
    )
  } else {
    return (
      <>
        <ModalInfo>Confirme os novos dados do reagendamento</ModalInfo>
        <ModalInfo>
          <strong>Data:</strong>{' '}
          {moment(scheduleBody.selectDay).format('DD/MM/YYYY')}
        </ModalInfo>
        <ModalInfo>
          <strong>Horário:</strong> {scheduleBody.selectTime}
        </ModalInfo>
        <ModalInfo>
          O seu reagendamento não vai gerar nenhum valor adicional.
        </ModalInfo>
        <ModalInfo>
          Tem certeza que deseja <strong>reagendar o serviço?</strong>
        </ModalInfo>
      </>
    )
  }
}

const RESCHEDULING = (onConfirm, onCancel, hasSchedulingChanged, scheduleBody, schedulingData, havePayment, professionalName) => ({
  type: 'action',
  title: <ModalTitle>Você confirma o reagendamento do serviço?</ModalTitle>,
  cancelLabel: 'Agora não',
  outlineCancelButton: true,
  confirmLabel: 'Confirmar reagendamento',
  onConfirm: onConfirm,
  onCancel: onCancel,
  iconSize: !hasSchedulingChanged ? 70 : undefined,
  icon: `${assetPrefix}/static/icons/calendar-check.svg`,
  body: getReschedulingModalBody(hasSchedulingChanged, scheduleBody, schedulingData, havePayment, professionalName)
})

const INCOMPLETE_PET_FORM = (pet, onConfirm) => ({
  title: 'Cadastro do Pet',
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  showBackButton: false,
  overflow: 'unset',
  overflowIncompletePet: 'unset',
  body: (<><IncompletePetDataForm pet={pet} onSuccess={onConfirm} /></>)
})

const LOGGOUT_MODAL = (onCancel, onConfirm) => ({
  title: 'Confirmação',
  type: 'warning',
  icon: `${assetPrefix}/static/icons/loggout-icon.svg`,
  cancelLabel: 'Cancelar',
  confirmLabel: 'Sair',
  onCancel: onCancel,
  onConfirm: onConfirm,
  showBackButton: false,
  body: <>Deseja realmente sair?</>
})

const PET_SAVE_SUCCESS = () => ({
  title: 'Dados salvos com sucesso',
  type: 'warning',
  icon: `${assetPrefix}/static/icons/check-green-circle.svg`,
  showBackButton: false,
  cancelLabel: 'Fechar'
})

const RESCHEDULING_SUCCESS = (onCancel) => ({
  showButtons: false,
  title: <ModalTitle>Seu serviço foi alterado com sucesso.</ModalTitle>,
  icon: `${assetPrefix}/static/icons/check-green-circle.svg`,
  cancelLabel: 'Fechar',
  onCancel: onCancel,
  showClose: false
})

const LOGIN_MODAL = ({ onCancel, callback }) => ({
  title: 'Acesse sua conta',
  subtitle: 'Personalize sua experiência e facilite seu agendamento',
  showBackButton: true,
  icon: <UserIconRounded />,
  children: (
    <LoginForm
      successCallback={callback}
      dataTest='login'
      onCancel={onCancel}
      cancelLabel='Acessar depois'
      confirmLabel={siteRecaptchaKey ? 'Acessar conta' : undefined}
    />
  )
})
const FORGOT_PASSWORD_MODAL = ({ onCancel, callback }) => ({
  title: 'Esqueceu a senha?',
  subtitle: 'Insira seu email para enviarmos um código para redefinir sua senha',
  decentralizedSubTitle: true,
  showBackButton: true,
  children: (
    <ForgotPasswordForm
      successCallback={callback}
      dataTest='login'
      onCancel={onCancel}
      confirmLabel='Enviar código'
    />
  ),
  largeHeaderGap: true
})
const RESET_PASSWORD_MODAL = ({ onCancel, callback }) => ({
  title: 'Redefinir senha',
  subtitle: 'Escolha uma nova senha seguindo os critérios abaixo',
  showBackButton: true,
  icon: <LockAlt />,
  children: (
    <ResetPasswordForm
      successCallback={callback}
      dataTest='login'
      onCancel={onCancel}
      cancelLabel='Voltar'
      confirmLabel='Salvar'
    />
  )
})
const SCHEDULE_RESERVED_LOGIN = ({ onCancel, callback }) => ({
  title: 'Acesse sua conta',
  subtitle: 'Para concluir o agendamento acesse sua conta ou crie uma nova.',
  showBackButton: true,
  icon: <UserIconRounded />,
  onCancel: onCancel,
  children: (
    <LoginForm
      successCallback={callback}
      dataTest='login'
      confirmLabel={siteRecaptchaKey ? 'Fazer login' : undefined}
    />
  )
})

const CREATE_ACCOUNT = ({ onCancel, callback, formData }) => ({
  title: 'Criar conta',
  showBackButton: true,
  onCancel: onCancel,
  children: <SignupForm formData={formData} onAccountCreated={callback} />
})

const USE_TERMS = ({ visible, callback }) => ({
  visible,
  dataTest: 'use-terms',
  showClose: false,
  children: <Terms onTermsAction={callback} />
})

const CONFIRM_NEW_ACCOUNT = ({ onCancel, ...props }) => ({
  title: 'Código de acesso',
  subtitle: 'Informe o código de acesso enviado para o e-mail da sua conta de acesso e clique em acessar conta.',
  decentralizedSubTitle: true,
  showBackButton: true,
  onCancel: onCancel,
  children: <ConfirmAccountForm {...props} />,
  largeHeaderGap: true
})

const SUCCESS_GENERIC = ({ title, message, confirmLabel, onConfirm }) => ({
  visible: true,
  type: 'info',
  title: title ?? 'Sucesso',
  body: message ?? '',
  confirmLabel: confirmLabel,
  fullButton: true,
  outlineCancelButton: true,
  icon: `${assetPrefix}/static/icons/hyper-check.svg`,
  onConfirm: onConfirm,
  noPadding: true,
  showClose: false
})

const EDIT_MULTIPLE_SCHEDULING = ({ onCancel, onConfirm }) => ({
  visible: true,
  cancelLabel: 'Agora não',
  confirmLabel: 'Alterar agendamento',
  type: 'info',
  title: 'Atenção',
  subtitle: 'Ao editar este agendamento, você perderá as informações do agendamento que está em andamento.',
  fullButton: true,
  outlineCancelButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  noPadding: true,
  showClose: false,
  dataTest: 'modal-edit-multiple-scheduling',
  onConfirm: onConfirm,
  onCancel: onCancel
})

const PAYMENT_PROBLEM = ({ onCancel, onConfirm, onClose }) => ({
  cancelLabel: 'Pagamento no local',
  confirmLabel: 'Revisar informações',
  type: 'danger',
  title: 'Pagamento não realizado',
  subtitle: 'Isso pode ocorrer por instabilidade na operadora ou dados incorretos. Por favor, revise essas informações ou siga para pagamento no local.',
  fullButton: true,
  outlineCancelButton: true,
  icon: `${assetPrefix}/static/icons/red-exclamation.svg`,
  noPadding: true,
  showClose: false,
  dataTest: 'payment-problem',
  onConfirm: onConfirm,
  onCancel: onCancel,
  onClose: onClose
})

const PAYMENT_SUCCESS = ({ onConfirm }) => ({
  confirmLabel: 'Fechar',
  type: 'success',
  title: 'Pagamento realizado com sucesso!',
  subtitle: 'Caso queira um serviço adicional, combine diretamente com a recepção',
  fullButton: true,
  icon: `${assetPrefix}/static/icons/hyper-check.svg`,
  noPadding: true,
  showClose: false,
  dataTest: 'payment-success',
  onConfirm: onConfirm
})

const PAYMENT_PROCESSING = ({ onConfirm }) => ({
  confirmLabel: 'Fechar',
  type: 'success',
  title: 'Estamos confirmando seu agendamento',
  subtitle: 'Pode levar alguns minutos para o sistema confirmar o seu atendimento. Por favor, aguarde um instante e confira na opção ”Meus agendamentos”',
  fullButton: true,
  icon: `${assetPrefix}/static/icons/warningIcon.svg`,
  noPadding: true,
  showClose: false,
  dataTest: 'payment-success',
  onConfirm: onConfirm
})

const ACCOUNT_CREATE_SUCCESS = (onConfirm) => ({
  title: 'Conta criada com sucesso.',
  type: 'warning',
  icon: `${assetPrefix}/static/icons/check-green-circle.svg`,
  showBackButton: false,
  confirmLabel: 'Fechar',
  onConfirm: onConfirm
})

const INFO_COUPON = ({ body }) => ({
  cancelLabel: 'Entendi',
  type: 'info',
  body,
  title: 'Regra de uso: Cupons',
  icon: `${assetPrefix}/static/icons/tag-coupon.svg`,
  showBackButton: false,
  showClose: true
})

const COUPON_LIMIT_REACHED_ERROR = (onConfirm, errorTitle) => ({
  type: 'warning',
  title: errorTitle,
  body: 'Um dos cupons aplicados foi esgotado. Volte e remova para seguir com seus agendamentos',
  fullButton: true,
  iconSize: '100%',
  icon: `${assetPrefix}/static/icons/pet-digging.svg`,
  onConfirm: onConfirm,
  confirmLabel: 'Voltar'
})

export default {
  SCHEDULE_ERROR_GENERIC,
  PARTNER_NOT_FOUND,
  EDIT_PET_WARNING,
  NEW_PET_WARNING,
  LOCATION_NOT_ALLOWED,
  DUPLICATED_SCHEDULING_WARNING,
  PROFESSIONAL_PROFILE,
  RESCHEDULING,
  RESCHEDULING_SUCCESS,
  LOGIN_MODAL,
  LOGGOUT_MODAL,
  SCHEDULE_RESERVED_LOGIN,
  CREATE_ACCOUNT,
  USE_TERMS,
  CONFIRM_NEW_ACCOUNT,
  FORGOT_PASSWORD_MODAL,
  RESET_PASSWORD_MODAL,
  SUCCESS_GENERIC,
  INCOMPLETE_PET_FORM,
  PET_SAVE_SUCCESS,
  EDIT_MULTIPLE_SCHEDULING,
  STEP_UPDATE,
  REPEAT_SCHEDULE_DATE_SELECTION,
  PAYMENT_PROBLEM,
  PAYMENT_SUCCESS,
  PAYMENT_PROCESSING,
  ACCOUNT_CREATE_SUCCESS,
  INFO_COUPON,
  COUPON_LIMIT_REACHED_ERROR
}
